export enum MessagesPT {
  ERR_BAD_RESPONSE = "Erro de inesperado",
  ERR_LOGIN = "Erro de autenticação",
  ERR_BAD_REQUEST = "Erro de autenticação",
  ERR_MEDIA_TYPE = "Tipo de arquivo inválido",
  GENERIC_ERROR = "Erro genérico",
  ERR_NOT_FOUND = "Nada encontrado",
  INVALID_PARAMS = "Parâmetros inválidos",
  DONE_COURSE = "Esse curso já foi concluído",
  VALIDATION = "Erro de validação de campo",
  UNDEFINED_ERROR = "Problemas de conexão",
  PERMISSION_DENIED = "Permissão negada",
  FEEDBACK_UNAVAILABLE = "Feedback indisponível",

  // SIGN UP
  EXISTENT = "Email já existe",
  EMAIL_SUCCESS = "Email enviado com sucesso",
  SIGNUP_SUCCESS = "Usuário cadastrado com sucesso",

  // EDIT
  EDIT_SUCCESS = "Alterações salvas com sucesso",
  EDIT_ERROR = "Erro ao salvar alterações",
  EXPIRED = "Sessão expirada",
  EMAIL_ERROR = "Erro no email",
  NOT_FOUND = "Erro inesperado",
  REQUIRED_FIELD = "Preencha os campos obrigatórios",

  // USERS
  USER_ADDED = "Novo usuário cadastrado com sucesso",
  USERS_ADDED = "Novos usuários cadastrados com sucesso",
  USER_UPDATED = "Usuário editado com sucesso",
  USER_STATUS = "Status alterado com sucesso",
  USER_NOT_FOUND = "Usuário não encontrado",
  COURSE_NOT_FOUND = "Curso não encontrado",
  DATA_ERROR = "Erro genérico",
  ALREADY_EXISTS = "Usuário Já existe",
  INVALID_CPF = "CPF inválido",
  UPLOAD = "Problemas ao enviar arquivo",
  CURRENT_PASSWORD_WRONG = "A senha atual está incorreta",
  PASSWORD_EDIT_SUCCESS = "Senha alterada com sucesso",
  ALREADY_ACTIVE = "Usuário já está ativo",

  // COURSES
  COURSE_ADDED = "Curso adicionado com sucesso",
  COURSE_UPDATED = "Curso atualizado com sucesso",
  COURSE_SENDED = "O curso foi enviado para aprovação",
  COURSE_PUBLISHED = "O curso foi publicado",
  COURSE_REPROVED = "O curso foi reprovado",
  CONNECTION_ERROR_COURSE_STATE = "Erro de conexão",

  //CHAPTERS
  CHAPTER_ADDED = "O capítulo foi adicionado",
  CHAPTER_UPDATED = "O capítulo foi atualizado",
  CHAPTER_NOT_DONE = "Veja todos os objetivos para fazer o quiz",

  // ORGANIZATION
  ORGANIZATION_ADDED = "Nova organização cadastrada com sucesso",
  ORGANIZATION_EDIT = "Organização editada com sucesso",

  //CATEGORIES
  CATEGORIE_DUPLICATED = "A categoria já foi adicionada",

  //MATERIALS
  MATERIAL_ERROR = "Não é permitido um material complementar sem pelo menos um obrigatório",
  MATERIAL_NOT_FOUND = "Material não foi encontrado",
  MATERIAL_TYPE_ERROR = "Tipo de material não é permitido",
  MATERIAL_LIMIT_SIZE = "Limite de arquivo excedido (450MB)",
  MATERIAL_ORDER = "Ordem do material atualizada",
  MATERIAL_ORDER_ERROR = "Só poderá alterada a ordem de um material da mesma classificação",
  MEDIA_ERROR = "Erro ao deletar material",

  //QUIZ
  NOT_FOUND_QUIZ = "Quiz não encontrado",
  HAS_CHECKED_QUESTION = "Essa questão não pode ser excluída",
  duration = "A duração deve ser de até 10 horas",
  QUIZ_ADDED = "As informações do quiz foram salvas com sucesso",

  //DRAG AND DROP
  RESPONSE_NOT_ADDED = "Resposta(s) não adicionada(s) ao item. ",
  OPTIONS_LIMIT_EXCEEDED = "O número de opções é limitado a 5",
  LENGTH_ITEMS_REQUIRED = "O número de items deve ser entre 3 e 5",

  //QUESTIONS
  QUESTION_ADDED = "A questão foi adicionada",
  QUESTION_UPDATED = "A questão foi atualizada",
  QUESTION_BEING_USED = "A questão não pode ser apagada, pois já está sendo utilizada em outro quiz",
  CSV_ERROR = "Erro no arquivo CSV",
  QUESTION_CREATED = "Questão criada com sucesso!",
  QUESTION_DELETED = "Questão excluída com sucesso!",

  //TRUE_OR_FALSE_QUESTION
  LIMIT_ITEMS_TRUE_OR_FALSE = "O limite para questões Verdadeiro/Falso é 5",

  //DRAG_AND_DROP
  LIMIT_ITEMS_DRAG_AND_DROP = "O número de items para a questão desse tipo deve ser entre 3 e 5",

  //GAP
  LIMIT_ITEMS_GAP = "O número de items para esse tipo de questão deve ser entre 3 e 5",

  //FEEDBACK
  NODE_ALREADY_LIKED = "Erro no feedback",

  //ATTENTION
  SETTINGS = "Configurações alteradas",

  CSV_OBS = "Não utilizar cabeçalho na importação, colocar apenas informações que serão importadas.",

  BLACKLIST_UPDATED = "Palavras-chaves atualizadas.",

  NO_CERTIFICATE = "O curso não possui certificado",

  //EVENT
  EVENT_CREATE_SUCCESS = "Evento criado com sucesso.",
  EVENT_CREATE_ERROR = "Não foi possível adicionar o evento.",
  EVENT_UPDATED_SUCCESS = "Atualização realizada com sucesso.",
  EVENT_UPDATED_ERROR = "Não foi possível salvar as atualizações do evento.",

  //CLASSROOM
  CLASSROOM_STATUS_ACTIVE = "Turma ativada com sucesso.",
  CLASSROOM_STATUS_INACTIVE = "Turma desativada com sucesso.",

  //CSV ERRORS
  "Invalid Email Format" = "Email inválido",
  "Email duplicate" = "Email duplicado",

  // FORUM
  FORUM_UPLOAD_SIZE_ERROR = "Arquivo muito grande (Tamanho máximo permitido: 10mb).",
  FORUM_UPLOAD_TYPE_ERROR = "Tipo de arquivo inválido.",
  FORUM_TOPIC_SAVED = "Tópico salvo com sucesso.",
  FORUM_TOPIC_UPDATED = "Tópico atualizado.",
  FORUM_COMMENT_SAVED = "Comentário publicado.",
  FORUM_COMMENT_DELETED = "Comentário excluido.",
  FORUM_COMMENT_DENOUNCED = "Comentário denunciado com sucesso.",
  TOPIC_MARKED_AS_RESOLVED = "Tópico marcado como resolvido!",
  TOPIC_MARKED_AS_CLOSED = "Tópico encerrado!",
  TOPIC_MARKED_AS_OPEN = "Tópico reaberto!",
  TOPIC_DELETED = "Tópico excluído.",
  FORUM_COMMENT_UPDATED = "Comentário atualizado.",
  TOPIC_DENOUNCE = "Tópico denunciado com sucesso.",
  DENOUNCED_TOPIC = "Não é possível atualizar ou excluir o tópico devido a denúncias.",
  DENOUNCED_COMMENT = "Não é possível atualizar ou excluir comentários devido a denúncias ativas.",
  COMMENT_DISABLED = "Este tópico foi resolvido ou fechado, os comentários estão desativados.",
  FORUM_DENOUNCE_ACCEPTED = "Denúncia(s) aceita(s).",
  FORUM_DENOUNCE_DISMISSED = "Denúncia(s) dispensada(s).",

  //AGENDA
  EVENT_DELETED = "Evento excluído!",
  VIDEO_DOWNLOADED = "Vídeo baixado com sucesso!",
  COPIED_LINK = "Link copiado com sucesso!",
  COPY_ERROR_LINK = "Erro ao copiar link.",
  DOWNLOAD_CLASS_ERROR = "Error ao fazer download!",

  //LEAN MESSAGES
  STATUS_ASSESSMENT_SUCCCESS = "Avaliação concluída com sucesso.",
  STATUS_ASSESSMENT_ERROR = "Erro ao enviar avalição.",

  //THEME
  THEME_LIMIT_IMAGE = "Limite de 5 imagens ultrapassado.",
  CREATE_SUBDNS = "Subdomínio já existe.",

  //ACTIVITIES
  ACTIVITY_CREATED = "Atividade criada com sucesso.",
  ACTIVITY_UPDATED = "Atividade atualizada com sucesso.",
  ACTIVITY_DELETED = "Atividade excluída com sucesso.",
  FEEDBACK_SUCCESS = "Atividade corrigida com sucesso.",

  ACTIVITY_STUDENT_SENT="Atividade foi enviada com sucesso",
}
